import AccountDialogs from "../dialogs/accounts/accountDialogs";

export const accountConfig = {
  title: "Account Management",
  columns: [
    { field: "accountName", headerName: "Account Name", type: "sort" },
    {
      field: "primaryContact",
      headerName: "Primary Contact",
      type: "multiSelectSort",
    },
    { field: "primaryEmail", headerName: "Primary Email", type: "sort" },
    { field: "accountType", headerName: "Account Type", type: "accountType" },
    { field: "manager", headerName: "Manager", type: "managerFilter" },
    { field: "bookkeeper", headerName: "Bookkeeper" },
    {
      field: "altUser",
      headerName: "Alt Users",
      type: "tooltip",
      disableFilter: true,
      tooltipField: "altUserNames",
    },
  ],
  dialogs: AccountDialogs,
  createButtonText: "Create Account",
  emptyMessage: "No accounts found",
};
